import * as undoActions from 'owa-mail-undo';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
/**
 * show notification on delete succeeded
 * @param numberOfItems acted on for the delete action
 */
export default function showNotificationOnDeleteSucceeded(numberOfItems) {
    if (!isMailFeatureEnabled('tri-notificationBar')) {
        return;
    }
    var notificationText = numberOfItems === 1
        ? strings.deleteItemSucceededNotification
        : format(strings.deleteItemsSucceededNotification, numberOfItems);
    lazyShowNotification.importAndExecute('deleteSucceededNotification', notificationText, {
        icon: "Delete" /* Delete */,
        primaryActionText: strings.undoAction,
        notificationCallback: function (reason) {
            if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                undoActions.lazyUndo.importAndExecute('NotificationBar');
            }
        },
    });
}
//# sourceMappingURL=showNotificationOnDeleteSucceeded.js.map